import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { createBeacons, fetchBeacons, fetchBeaconsStore, fetchBeaconsTypes, SearchBeaconsStores } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useDebounce } from '@/utils/DebounceHook';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import axios from 'axios';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    getBeacons: any
    setshowAddBeaconDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}
const AddSingleBeaconDrawer: React.FC<ProductsDrawerProps> = ({ getBeacons, setshowAddBeaconDrawer }) => {
    const [submitting, setSubmitting] = useState(false)
    const [searchTermForBeacon, setSearchTermForBeacon] = useState('')
    const [BeaconStoresToDisplay, setBeaconsStoresToDisplay] = useState([])
    const [BeaconStoresToOptions, setBeaconStoresToOptions] = useState([])
    const [searchTermForBeaconType, setSearchTermForBeaconType] = useState('')
    const [BeaconTypesToDisplay, setBeaconsTypesToDisplay] = useState([])
    const [BeaconTypesOptions, setBeaconTypesOptions] = useState([])
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();


    const getBeaconsStores = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconStore', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setBeaconsStoresToDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        getBeaconsStores()
    }, [])

    const getBeaconsTypes = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconTypes', {
            signal: controller.signal
        }).then((response: any) =>
            response.data.data
        ).then((data: any) => {
            if (isMounted) {
                setBeaconsTypesToDisplay(data)
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        getBeaconsTypes()
    }, [])



    const searchBeaconStoresBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beaconStore/search?query=${searchTermForBeacon}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setBeaconsStoresToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeacon, 500, searchBeaconStoresBySearchTerm)

    const searchBeaconTypesBySearchTerm = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beaconTypes/search?query=${searchTermForBeaconType}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setBeaconsTypesToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTermForBeaconType, 500, searchBeaconTypesBySearchTerm)


    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }



    const onFinish = (beacons: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/beacons', beacons, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                successNotification(
                    "Beacon successfully added",
                    ` beacon added to the system`,
                    'topRight'
                )
            }
            getBeacons()
            setshowAddBeaconDrawer(false)
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }
    const handleBeaconStoreChange = (value: any) => {
        setSearchTermForBeacon(value)
    }
    const handleBeaconTypeChange = (value: any) => {
        setSearchTermForBeaconType(value)
    }

    useEffect(() => {
        const updatedBeaconStoreOptions: any = BeaconStoresToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setBeaconStoresToOptions(updatedBeaconStoreOptions)
    }, [BeaconStoresToDisplay])

    useEffect(() => {
        const updatedBeaconTypesOptions: any = BeaconTypesToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setBeaconTypesOptions(updatedBeaconTypesOptions)
    }, [BeaconTypesToDisplay])

    const filterBeaconsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }

    const filterBeaconsTypesOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false
    }


    return (
        <>
            <Form layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                form={form}
                hideRequiredMark>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="beacon_store_id"
                            label="beacon Store"
                            rules={[{ required: true, message: 'Please slect product name' }]}
                        >
                            <Select
                                placeholder="Please select product name"
                                showSearch
                                style={{ borderColor: 'black' }}
                                onSearch={handleBeaconStoreChange}
                                filterOption={filterBeaconsOptions}
                            >
                                {BeaconStoresToOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="beacon_type_id"
                            label="beacon type"
                            rules={[{ required: true, message: 'Please slect beacon type' }]}
                        >
                            <Select
                                placeholder="Please select beacon type"
                                showSearch
                                style={{ borderColor: 'black' }}
                                onSearch={handleBeaconTypeChange}
                                filterOption={filterBeaconsTypesOptions}
                            >
                                {BeaconTypesOptions.map((option: any) => (
                                    <Option key={option.value} value={option.value}>{option.label}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="cid"
                            label="cid"
                            rules={[{ required: true, message: 'Please enter cid' }]}
                        >
                            <Input
                                placeholder="Please enter cid"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="uuid"
                            label="uuid"
                            rules={[{ required: true, message: 'Please enter uuid' }]}
                        >
                            <Input
                                placeholder="Please enter uuid"
                                className='focus:border-green-500 hover:border-green-500'
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="tag_no"
                            label="tag No"
                            rules={[{ required: true, message: 'Please enter cid' }]}
                        >
                            <Input
                                placeholder="Please enter cid"
                                className='focus:border-green-500 hover:border-green-500'
                                autoComplete="off" 
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                Submit
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        </>
    )
}

export default AddSingleBeaconDrawer;


